module.exports = __webpack_public_path__ + "static/img/2_2_3_4.965ce9bc.jpg";